import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// constants

// actions
import { getCorporates, CorporateApiResponseSuccess, CorporateApiResponseError } from "./actions";

// API helpers
import { addCorporateApi, deleteCorporateApi, getCorporatesApi, updateCorporateApi } from "../../helpers/api/corporates";
import { CorporateActionTypes } from "./constants";
import { MAX_ITEMS_PER_PAGE } from "../../helpers/api/apiCore";

// ──────────────────────────────────────────────
// 📦 GET Corporates
function* getCorporatesSaga({ payload: { status, page, limit } }: any): SagaIterator {
  try {
    const response = yield call(getCorporatesApi, status, page, limit);
    const corporates = response?.data;

    yield put(CorporateApiResponseSuccess(CorporateActionTypes.GET_CORPORATES, corporates));
  } catch (error: any) {
    yield put(CorporateApiResponseError(CorporateActionTypes.GET_CORPORATES, error));
  }
}

// ──────────────────────────────────────────────
// ✏️ UPDATE Corporate
function* updateCorporateSaga({ payload: { id, name, email, phone, address, is_active, code } }: any): SagaIterator {
  try {
    const response = yield call(updateCorporateApi, { id, name, email, phone, address, is_active, code });
    const message = response?.data?.message;

    yield put(CorporateApiResponseSuccess(CorporateActionTypes.UPDATE_CORPORATES, message));
    yield put(getCorporates(undefined, 1, MAX_ITEMS_PER_PAGE));
  } catch (error: any) {
    yield put(CorporateApiResponseError(CorporateActionTypes.UPDATE_CORPORATES, error));
  }
}

// ──────────────────────────────────────────────
// ➕ ADD Corporate
function* addCorporateSaga({ payload: { name, email, phone, address, is_active, code } }: any): SagaIterator {
  try {
    const response = yield call(addCorporateApi, { name, email, phone, address, is_active, code });
    const message = response?.data?.message;

    yield put(CorporateApiResponseSuccess(CorporateActionTypes.ADD_CORPORATES, message));
    yield put(getCorporates(undefined, 1, MAX_ITEMS_PER_PAGE));
  } catch (error: any) {
    yield put(CorporateApiResponseError(CorporateActionTypes.ADD_CORPORATES, error));
  }
}

// ──────────────────────────────────────────────
// 🗑️ DELETE Corporate
function* deleteCorporateSaga({ payload: { id } }: any): SagaIterator {
  try {
    const response = yield call(deleteCorporateApi, { id });
    const message = response?.data?.message;

    yield put(CorporateApiResponseSuccess(CorporateActionTypes.DELETE_CORPORATES, message));
    yield put(getCorporates(undefined, 1, MAX_ITEMS_PER_PAGE));
  } catch (error: any) {
    yield put(CorporateApiResponseError(CorporateActionTypes.DELETE_CORPORATES, error));
  }
}

// ──────────────────────────────────────────────
// 👀 WATCHERS
export function* watchGetCorporates() {
  yield takeEvery(CorporateActionTypes.GET_CORPORATES, getCorporatesSaga);
}

export function* watchUpdateCorporate() {
  yield takeEvery(CorporateActionTypes.UPDATE_CORPORATES, updateCorporateSaga);
}

export function* watchAddCorporate() {
  yield takeEvery(CorporateActionTypes.ADD_CORPORATES, addCorporateSaga);
}

export function* watchDeleteCorporate() {
  yield takeEvery(CorporateActionTypes.DELETE_CORPORATES, deleteCorporateSaga);
}

// ──────────────────────────────────────────────
// 🌐 ROOT SAGA
function* CorporatesSaga() {
  yield all([fork(watchGetCorporates), fork(watchUpdateCorporate), fork(watchAddCorporate), fork(watchDeleteCorporate)]);
}

export default CorporatesSaga;
